import { NotificationState, NotificationType } from './types';

const initialState: NotificationState = {
  items: [],
  notificationType: NotificationType.inApp,
  pushId: '',
  showTooltip: false,
  replyReminderShown: false,
};

export default initialState;
